import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GetRacunQuery, RacuniClient, TipTransakcije, UplataRacunaTableDto } from '@kodit/core/data-api';
import { DynamicDialogConfig, DynamicDialogService } from '@kodit/core/shared-ui';
import {
  ActionType,
  OnTableInit,
  TableConfig,
} from 'libs/core/shared-ui/src/lib/table/table-common';
import { Subscription } from 'rxjs';
import { DodatneUplateRacunaFormComponent } from '../dodatne-uplate-racuna-form/dodatne-uplate-racuna-form.component';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { ConfirmationService } from 'primeng/api';
import { AlertService, SharedService } from '@kodit/core/services';
import { RacunInfoService } from '../racun-info/racun-info.service';

@Component({
  selector: 'kodit-uplate-po-racunu-table',
  templateUrl: './uplate-po-racunu-table.component.html',
  styleUrls: ['./uplate-po-racunu-table.component.scss'],
})
export class UplatePoRacunuTableComponent
  implements OnInit, OnDestroy, OnTableInit {
  /** Subs */
  private _getSub: Subscription = new Subscription();
  private _subs: Subscription = new Subscription();

  izmenaDialogConfig: DynamicDialogConfig = new DynamicDialogConfig(
    DialogSize.SMALL
  );

  /** Configurations */
  tableConfig: TableConfig;

  /** I/O */
  @Input() uplateTable: UplataRacunaTableDto[] = [];

  constructor(
    private _dialogService: DynamicDialogService,
    private _confirmationService: ConfirmationService,
    private _sharedService: SharedService,
    private _alertService: AlertService,
    private _racunInfoService: RacunInfoService,
    private _client: RacuniClient
  ) {}

  ngOnInit(): void {
    this.setTableConfig();
  }

  async setTableConfig(): Promise<void> {
    this.tableConfig = new TableConfig({
      tableHeader: '',
      columns: [
        { field: 'izvor', header: 'Izvor', type: 'text' },
        {
          field: 'datumEvidentiranja',
          header: 'Datum',
          type: 'text',
        },
        {
          field: 'iznos',
          header: 'Iznos',
          type: 'number',
        },
      ],
      rowActions: [
        {
          type: ActionType.EDIT,
          hasAccessTooltip: 'Izmenite arhivsku knjigu',
          callback: (index: number) => {
            const forEdit = this.uplateTable[index];
            this.izmenaDialogConfig.data = {
              id: forEdit?.id,
              model: this._racunInfoService.getRacunInfoDto,
              iznosUplate: forEdit?.iznosBroj
            };
            this.izmenaDialogConfig.header = 'Izmena podataka uplate';
            this.openDialog(this.izmenaDialogConfig);
          },
          shouldDisplayByCondition: (rowData: UplataRacunaTableDto) => {
            return this._shouldDisplayEditAndDelete(
                rowData.tipTransakcije! !== TipTransakcije.PROVIZIJA_BANKE 
                && rowData.tipTransakcije! !== TipTransakcije.KURSNA_RAZLIKA
                && rowData.tipTransakcije! !== TipTransakcije.KAMATNA_NAKNADA
            );
          },
        },
        {
          type: ActionType.DELETE,
          hasAccessTooltip: 'Obrišite arhivski zapis',
          noAccessTooltip: 'Nemate ovlašćenja za brisanje arhivske knjige',
          callback: (index: number) => {
            this._confirmationService.confirm({
              header: 'Potvrda brisanja',
              message: 'Da li želite da obrišete uplatu?',
              acceptLabel: 'Obriši',
              rejectLabel: 'Odustani',
              rejectButtonStyleClass: 'p-button-outlined',
              accept: () => {
                this._deleteDodatnaUplataRacuna(index);
              },

            });
          },
          shouldDisplayByCondition: (rowData: UplataRacunaTableDto) => {
            return this._shouldDisplayEditAndDelete(
                rowData.tipTransakcije! !== TipTransakcije.PROVIZIJA_BANKE 
                && rowData.tipTransakcije! !== TipTransakcije.KURSNA_RAZLIKA
                && rowData.tipTransakcije! !== TipTransakcije.KAMATNA_NAKNADA
            );
          },
        },
      ],
    });
  }

  // private _goToIzvod(rowIndex: number) {
  //   this._router.navigate([
  //     '/banka',
  //     'izvodi',
  //     'obrada-izvoda',
  //     // this.uplateTable[rowIndex].rutiranjeIzvodaDto.izvodId,
  //   ]);
  // }

  openDialog(config: DynamicDialogConfig): void {
    const ref = this._dialogService.open(DodatneUplateRacunaFormComponent, config);

    this._subs.add(
        ref.onClose.subscribe(() => {
          this._subs.add(
            this._client
              .getRacunInfo(new GetRacunQuery({ id: this._racunInfoService.racunInfoDto$.value.id }))
              .subscribe((res) => {
                this._racunInfoService.setRacunInfoDto = res.data;
              })
          )
      })
    );
  }

  private _deleteDodatnaUplataRacuna(index: number) {
    this._subs.add(
      this._client
        .deleteDodatnuUplatu(this.uplateTable[index].id!)
        .subscribe((res) => {
          if (res.succeeded) {
            this._alertService.addSuccessMsg(res.messages![0]);
            this._subs.add(
              this._client
                .getRacunInfo(new GetRacunQuery({ id: this._racunInfoService.racunInfoDto$.value.id }))
                .subscribe((res) => {
                  this._racunInfoService.setRacunInfoDto = res.data;
              }))
          }
        })
    );
  }

  private _shouldDisplayEditAndDelete(isDisabled: boolean) {
    return !isDisabled;
  }

  ngOnDestroy(): void {
    this._getSub.unsubscribe();
    this._subs.unsubscribe();
  }
}
